import { Directive, ElementRef, AfterViewInit } from '@angular/core';
import { AppUtilityService } from '../services/app-utility.service';

// Progress Bar Directive
@Directive({
  selector: '[appProgressbar]',
  standalone: true
})
export class ProgressbarDirective implements AfterViewInit {
  constructor(private el: ElementRef, private appUtility: AppUtilityService) {}
  ngAfterViewInit() {
    this.appUtility.loadingIndicator.api = window.mdc.linearProgress.MDCLinearProgress.attachTo(this.el.nativeElement);
    this.appUtility.loadingIndicator.api.determinate = false;
    this.appUtility.loadingIndicator.api.close();
  }
}

// Switch Directive
@Directive({
  selector: '[appSwitch]',
  standalone: true
})
export class SwitchDirective implements AfterViewInit {
  constructor(private el: ElementRef) {}
  ngAfterViewInit() {
    window.mdc.switchControl.MDCSwitch.attachTo(this.el.nativeElement);
  }
}

@Directive({
  selector: '[appTooltip]',
  standalone: true
})
export class TooltipDirective implements AfterViewInit {
  constructor(private el: ElementRef) {}
  ngAfterViewInit() {
    if (window.mdc?.tooltip?.MDCTooltip) {
      window.mdc.tooltip.MDCTooltip.attachTo(this.el.nativeElement);
    }
  }
}

// Export all directives for easy import
export const APP_DIRECTIVES = [
  ProgressbarDirective,
  SwitchDirective,
  TooltipDirective
];

// Global declarations for MDC
declare global {
  interface Window {
    mdc: any;
  }
  interface Document {
    webkitExitFullscreen: () => void;
    msExitFullscreen: () => void;
  }
}